import PocketBase from 'pocketbase';

const url = import.meta.env.VITE_POCKETBASE_URL;
if (!url) {
  throw new Error('VITE_POCKETBASE_URL is not set. Copy .env.example to .env and fill it in.');
}

/** Shared PocketBase client. authStore persists to localStorage by default. */
export const pb = new PocketBase(url);

// React StrictMode double-invokes effects in dev; disabling auto-cancellation
// avoids spurious "autocancelled" errors from overlapping identical requests.
pb.autoCancellation(false);

/** Absolute URL for a record file field (e.g. a post image). */
export function fileUrl(
  record: { id: string; collectionId: string; collectionName: string },
  filename: string,
  thumb?: string,
): string {
  if (!filename) return '';
  return pb.files.getURL(record, filename, thumb ? { thumb } : undefined);
}
